import * as React from "react";
const Quotes = (props) => (
  <svg
    width={27}
    height={21}
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.85286 18.8127C1.39453 17.2085 0.519531 15.4585 0.519531 12.5418C0.519531 7.43766 4.16537 2.91683 9.26953 0.583496L10.582 2.47933C5.76953 5.10433 4.7487 8.4585 4.45703 10.646C5.1862 10.2085 6.20703 10.0627 7.22787 10.2085C9.85287 10.5002 11.8945 12.5418 11.8945 15.3127C11.8945 16.6252 11.3112 17.9377 10.4362 18.9585C9.41537 19.9793 8.2487 20.4168 6.79037 20.4168C5.1862 20.4168 3.72786 19.6877 2.85286 18.8127ZM17.4362 18.8127C15.9779 17.2085 15.1029 15.4585 15.1029 12.5418C15.1029 7.43766 18.7487 2.91683 23.8529 0.583496L25.1654 2.47933C20.3529 5.10433 19.332 8.4585 19.0404 10.646C19.7695 10.2085 20.7904 10.0627 21.8112 10.2085C24.4362 10.5002 26.4779 12.5418 26.4779 15.3127C26.4779 16.6252 25.8945 17.9377 25.0195 18.9585C24.1445 19.9793 22.832 20.4168 21.3737 20.4168C19.7695 20.4168 18.3112 19.6877 17.4362 18.8127Z"
      fill="#134A85"
    />
  </svg>
);
export default Quotes;
